export default {
    state: {
        dependentOptions: [
            {
                id: 'saldo',
                icon: 'fas fa-dollar-sign',
                display: 'Saldo',
                action: '/balance',
                showBalance: true,
                isVisible: true,
                permission: 'CONSULTASALDO'
            },
            {
                id: 'bloquear',
                icon: 'fas fa-credit-card',
                display: 'Bloquear/#Desbloquear#Cartão',
                cardStatus: true,
                type: 'defaultDialog',
                isVisible: true,
                permission: 'BLOQUEACARTAO'
            },
            {
                id: 'financialSummary',
                icon: 'fas fa-file-invoice-dollar',
                display: 'Resumo#Financeiro',
                action: '/financialSummary',
                isVisible: true,
                permission: 'CONSULTAEXTRATO'
            },
            {
                id: 'financialResponsible',
                icon: 'fas fa-user-tie',
                display: 'Responsável#Financeiro',
                action: '/financialResponsible',
                checkVisibility: true,
                isVisible: true
            },
            {
                id: 'foodRestriction',
                icon: 'fas fa-utensils',
                display: 'Restrição#Alimentar',
                action: '/foodRestriction',
                isVisible: true,
                permission: 'RESTRICAOALIMENTAR'
            },
            {
                id: 'valueRestriction',
                icon: 'fas fa-money-bill-wave',
                display: 'Restrição#por Valor',
                action: '/valueRestriction',
                isVisible: true,
                permission: 'RESTRICAOVALOR'
            },
            {
                id: 'automaticRecharge',
                icon: 'fas fa-clock-rotate-left',
                display: 'Recarga#Automática',
                action: '/automaticRecharge',
                isVisible: true,
                permission: 'RECARGAAUTOCARTAO'
            },
            {
                id: 'qrcode',
                icon: 'fas fa-qrcode',
                display: 'QrCode do#Cartão',
                action: '/qrcode',
                isVisible: true
            },
            {
                id: 'invoiceSummary',
                icon: 'fas fa-file-invoice',
                display: 'Resumo das#Faturas',
                action: '/invoiceSummary',
                isVisible: true
            },
            {
                id: 'subscriptionServices',
                icon: 'fas fa-wallet',
                display: 'Serviços por#Assinatura',
                action: '/subscriptionServices',
                isVisible: false
            }
        ]
    },
    mutations: {
        toggleVisibleCards (state, data) {
            state.dependentOptions.forEach(element => {
                if (element.id === data.id) {
                    element.isVisible = data.value
                }
            })
        }
    },
    actions: {
        toggleVisibleCards ({ commit }, data) {
            commit('toggleVisibleCards', data)
        }
    },
    getters: {
        // make all fields with isVisible property true except those with checkVisibility property true
        dependentOptions: (state) => {
            return state.dependentOptions
        }
    }
}
